import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsButtonTypes } from '@upr-gds-web/components';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get, isArray } from 'lodash-es';
class GdsButtonModelServiceModule {
  static {
    this.ɵfac = function GdsButtonModelServiceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsButtonModelServiceModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsButtonModelServiceModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsButtonModelServiceModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsButtonModelService {
  constructor(injector) {
    this.injector = injector;
    this.buttonArray = [];
  }
  get utilities() {
    if (!this._utilities) {
      this._utilities = this.injector.get(GdsCommonUtilityService);
    }
    return this._utilities;
  }
  init(field, isMedia, isArray, isXpath) {
    // TODO: Remove legacy functionality when mediaButton field is no longer in use.
    if (isMedia) {
      return this.parseLegacyMediaButton(field, isXpath);
    }
    const embeddedValues = get(field, 'EmbeddedValues', []);
    this.buttonArray = [];
    for (let i = 0; i <= embeddedValues.length - 1; i++) {
      const btnType = get(field, `EmbeddedValues[${i}].type.Values[0]`);
      const target = get(field, `EmbeddedValues[${i}].target.KeywordValues[0].Key`);
      const label = isXpath ? get(field, `EmbeddedValues[${i}].label.XPath`) : get(field, `EmbeddedValues[${i}].label.Values[0]`);
      const analytics = get(field, `EmbeddedValues[${i}].analytics.Values[0]`);
      const title = get(field, `EmbeddedValues[${i}].title.Values[0]`);
      const ariaLabel = get(field, `EmbeddedValues[${i}].ariaLabel.Values[0]`);
      const svg = get(field, `EmbeddedValues[${i}].svgOptions.KeywordValues[0].Key`);
      const customEventDetail = get(field, `EmbeddedValues[${i}].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.customEventDetail.EmbeddedValues`) || get(field, `EmbeddedValues[${i}].customEventDetail.EmbeddedValues`);
      const action = get(field, `EmbeddedValues[${i}].action.KeywordValues[0].Key`);
      if (btnType === 'none') {
        return null;
      }
      if (target === 'youtube') {
        const youtubeUrl = this.utilities.getHref(embeddedValues[i]);
        this.buttonArray.push({
          label,
          analytics,
          type: btnType,
          target,
          svgOptions: {
            iconName: svg
          },
          title: title || label,
          ariaLabel: ariaLabel || label,
          videoCaption: ariaLabel,
          videoId: youtubeUrl,
          href: youtubeUrl,
          customEventDetail: customEventDetail,
          action
        });
      } else if (btnType) this.buttonArray.push({
        label,
        href: this.utilities.getHref(embeddedValues[i]),
        anchor: this.utilities.getAnchor(embeddedValues[i]),
        analytics,
        type: btnType,
        target,
        svgOptions: {
          iconName: svg
        },
        title,
        ariaLabel,
        modalContent: get(field, `EmbeddedValues[${i}].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.elements`),
        customEventDetail,
        action
      });else {
        this.buttonArray.push({
          label,
          ariaLabel,
          analytics,
          svgOptions: {
            iconName: svg
          }
        });
      }
    }
    return isArray ? this.buttonArray : this.buttonArray[0];
  }
  initRelatedTileLink(tileLink) {
    return {
      href: this.utilities.getHref(get(tileLink, 'PageUrl'), false),
      analytics: get(tileLink, 'PageUrlAnalyticsID'),
      ariaLabel: get(tileLink, 'PageUrlAriaLabel')
    };
  }
  getSvgIconName(buttons, i) {
    // sometimes svOptions contains iconName directly as a string, sometimes as an object with iconName property
    let iconName = get(buttons, `[${i}].svgOptions`, '');
    if (typeof iconName === 'object') {
      iconName = get(iconName, 'iconName', '');
    }
    return iconName;
  }
  mapButtonData(buttons) {
    if (!!buttons && !isArray(buttons)) {
      buttons = [buttons]; // code below expects array, turn arg into one if needed
    }
    if (!!buttons && buttons.length > 0) {
      const buttonArray = [];
      for (let i = 0; i <= buttons.length - 1; i++) {
        const target = get(buttons, `[${i}].target`, '');
        const keys = Object.keys(buttons[i]);
        const type = get(buttons, `[${i}].type`, '');
        if (type === 'none') {
          continue;
        } else if (keys.length === 2 && keys.includes('target') && keys.includes('type')) {
          buttonArray.push({});
        } else {
          buttonArray.push({
            label: get(buttons, `[${i}].label`, ''),
            analytics: get(buttons, `[${i}].analytics`, ''),
            type: type,
            target,
            description: get(buttons, `[${i}].description`, ''),
            href: this.utilities.resolveLinkUrl(get(buttons, `[${i}].link[0].External`, ''), target) || this.utilities.resolveLinkUrl(get(buttons, `[${i}].href[0].External`) || get(buttons, `[${i}].href`), target) || this.utilities.resolveLinkUrl(get(buttons, `[${i}].link[0].Component[0].ResolvedUrl`, ''), target),
            image: this.utilities.resolveImagePath(get(buttons, `[${i}].image`, '')),
            svgOptions: {
              iconName: this.getSvgIconName(buttons, i)
            },
            title: get(buttons, `[${i}].title`, '') || get(buttons, `[${i}].label`, ''),
            ariaLabel: get(buttons, `[${i}].ariaLabel`, '') || get(buttons, `[${i}].label`, ''),
            videoId: get(buttons, `[${i}].videoId`, ''),
            videoCaption: get(buttons, `[${i}].vidoeCaption`, ''),
            modalContent: get(buttons, `[${i}].link[0].Component[0].elements`, '') || get(buttons, `[${i}].modalContent`, ''),
            customEventDetail: get(buttons, `[${i}].link[0].Component[0].customEventDetail`, '')
          });
        }
      }
      return buttonArray.length === 1 ? buttonArray[0] : buttonArray;
    }
  }
  mapProfileButtonData(buttons) {
    if (!!buttons && buttons.length > 0) {
      const buttonArray = [];
      for (let i = 0; i <= buttons.length - 1; i++) {
        buttonArray.push({
          label: get(buttons, `[${i}].button[0].label`, ''),
          analytics: get(buttons, `[${i}].button[0].analytics`, ''),
          flag: get(buttons, `[${i}].flag`, ''),
          // type: get(buttons, `[${i}].button[0].type`, ''),
          type: GdsButtonTypes.hamburgerNavSecondary,
          // Temp hardcode until Tridion data is correct
          target: get(buttons, `[${i}].button[0].target`, ''),
          description: get(buttons, `[${i}].button[0].description`, ''),
          href: this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].External`, '')) || this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].href[0].External`, '')) || this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].Component[0].ResolvedUrl`, '')) || this.utilities.resolveLinkUrl(get(buttons, `[${i}].button[0].link[0].Component[0].ResolvedUrl`, '')),
          image: this.utilities.resolveImagePath(get(buttons, `[${i}].button[0].image`, '')),
          svgOptions: {
            iconName: get(buttons, `[${i}].button[0].svgOptions`, '')
          },
          title: get(buttons, `[${i}].button[0].title`, '') || get(buttons, `[${i}].button[0].label`, ''),
          ariaLabel: get(buttons, `[${i}].button[0].ariaLabel`, '') || get(buttons, `[${i}].button[0].label`, ''),
          videoId: get(buttons, `[${i}].button[0].videoId`, ''),
          videoCaption: get(buttons, `[${i}].button[0].vidoeCaption`, ''),
          modalContent: get(buttons, `[${i}].button[0].link[0].Component[0].elements`, ''),
          customEventDetail: get(buttons, `[${i}].button[0].link[0].Component[0].customEventDetail`, '')
        });
      }
      return buttonArray.length === 1 ? buttonArray[0] : buttonArray;
    }
  }
  mapProfileToggleButtonData(toggleButtons) {
    if (!!toggleButtons && toggleButtons.length > 0) {
      const toggleButtonArray = [];
      for (let i = 0; i <= toggleButtons.length - 1; i++) {
        toggleButtonArray.push({
          label: get(toggleButtons, `[${i}].toggleButton[0].label`, ''),
          analytics: get(toggleButtons, `[${i}].toggleButton[0].analytics`, ''),
          flag: get(toggleButtons, `[${i}].flag`, ''),
          eventName: get(toggleButtons, `[${i}].eventName`, ''),
          positiveLabel: get(toggleButtons, `[${i}].toggleButton[0].positiveLabel`, ''),
          negativeLabel: get(toggleButtons, `[${i}].toggleButton[0].negativeLabel`, ''),
          ariaLabel: get(toggleButtons, `[${i}].toggleButton[0].ariaLabel`, '') || get(toggleButtons, `[${i}].toggleButton[0].label`, '')
        });
      }
      return toggleButtonArray.length === 1 ? toggleButtonArray[0] : toggleButtonArray;
    }
  }
  parseLegacyMediaButton(field, isXpath) {
    const label = isXpath ? get(field, 'EmbeddedValues[0].label.XPath') : get(field, 'EmbeddedValues[0].label.KeyWordValues[0].Title') || get(field, 'EmbeddedValues[0].label.Values[0]');
    const mediaBtnData = {
      label: label,
      analytics: get(field, 'EmbeddedValues[0].analytics.Values[0]'),
      type: get(field, 'EmbeddedValues[0].label.KeyWordValues[0].Key'),
      title: get(field, 'EmbeddedValues[0].title.Values[0]') || label,
      ariaLabel: get(field, 'EmbeddedValues[0].ariaLabel.Values[0]') || label,
      videoId: get(field, `EmbeddedValues[0].videoId.Values[0]`),
      videoCaption: get(field, `EmbeddedValues[0].vidoeCaption.Values[0]`)
    };
    // only populate default 'play' type when mediaButton is not empty
    const hasMediaBtnData = Object.values(mediaBtnData).some(val => val !== undefined && val !== null);
    if (hasMediaBtnData && !mediaBtnData.type) mediaBtnData.type = GdsButtonTypes.play;
    return mediaBtnData;
  }
  static {
    this.ɵfac = function GdsButtonModelService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsButtonModelService)(i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsButtonModelService,
      factory: GdsButtonModelService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsButtonModelService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();

/*
 * Public API Surface of gds-button-model-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsButtonModelService, GdsButtonModelServiceModule };
